import { apiRequest } from "../../index";
import config from "../../../../config";

const { VCHAT_API } = config;
const api = `${VCHAT_API}/transcription`;

export async function createTranscription(body) {
  try {
    const response = await apiRequest(`${api}/transcription`, "POST", body);
    return response;
  } catch (err) {
    throw err;
  }
}
